import sgccApi from "@/api/sgccApi"

export const obtainAllPecunaryRights = async ( { commit } ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.get(`/api/derechosPecunarios`)
        if (data.ok) {
            commit('setPecunaryRights', data.derechoPecunario)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error }
    }
}


export const editPecunaryRights = async ( _, { form } ) => {
    const pecunaryRightsForm = {
        concepto: form.concepto,
        valor: form.valor,
        programa_id: form.programa_id,
        nivel_academico_id: form.nivel_academico_id,
        numDividir: form.numDividir,
        estado: form.estado == 1 ? true : false
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.put(`/api/derechosPecunarios/${form.id}`, pecunaryRightsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error?.response?.data?.message }
    }
}

export const createPecunaryRights = async ( _, { form } ) => {
    const pecunaryRightsForm = {
        concepto: form.concepto,
        valor: form.valor,
        programa_id: form.programa_id,
        nivel_academico_id: form.nivel_academico_id,
        numDividir: form.numDividir,
        estado: form.estado == 1 ? true : false
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post(`/api/derechosPecunarios`, pecunaryRightsForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error?.response?.data?.message }
    }
}

export const deletePecunaryRights = async ( _, id ) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.delete(`/api/derechosPecunarios/${id}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}